import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { RouterLink } from '@angular/router';

import { CustomModuleComponent } from '@usheru-hff/custom-page/feature-custom-page';

@Component({
  standalone: true,
  imports: [CommonModule, RouterLink],
  selector: 'work-with-us',
  styleUrls: ['./work-with-us.component.scss'],
  template: `
    @if (data()) {
      <div class="work-with-us-container">
        <h2>{{ data()?.title }}</h2>
        <p>{{ data()?.text }}</p>
        <a [routerLink]="data()?.linkUrl" class="cta-link button">{{ data()?.linkLabel }}</a>
        <img [src]="data()?.imageBackground" alt="background image" class="bg-image" />
      </div>
    }
  `
})
export class WorkWithUsComponent implements CustomModuleComponent {
  data = signal<
    | {
        title: string;
        text: string;
        linkUrl: string;
        linkLabel: string;
        imageBackground: string;
      }
    | undefined
  >(undefined);
}
